const t = {
  name: "Rules",
  dimensions: { width: 20, height: 21 },
  content: `
    <g fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
      <path d="M11 3.25H19" />
      <path d="M11 10.25H19" />
      <path d="M11 18.25H19" />
      <path d="M7 1.25L3 5.25" />
      <path d="M1 3.25L3 5.25" />
      <path d="M7 8.25L3 12.25" />
      <path d="M1 10.25L3 12.25" />
      <path d="M7 15.25L3 19.25" />
      <path d="M1 17.25L3 19.25" />
    </g>
  `
};
export {
  t as Rules
};
